import { STUDY_TERRITORY_TREE, type LandscapeId } from "../data/landscapes";

type TerritoryHierarchyProps = {
  readonly selectedId?: LandscapeId | null;
  readonly onSelect?: (id: LandscapeId) => void;
  readonly interactive?: boolean;
};

/**
 * Nested territory outline: Région → Préfectures → Localités.
 * Used on both story steps so the administrative reading order stays constant.
 */
export function TerritoryHierarchy({
  selectedId = null,
  onSelect,
  interactive = false,
}: TerritoryHierarchyProps) {
  return (
    <div className="nbs-territory-tree" data-testid="territory-hierarchy">
      <p className="nbs-territory-tree__region">{STUDY_TERRITORY_TREE.label}</p>
      <ul className="nbs-territory-tree__prefectures">
        {STUDY_TERRITORY_TREE.prefectures.map((prefecture) => (
          <li key={prefecture.id} className="nbs-territory-tree__prefecture">
            <p className="nbs-territory-tree__prefecture-label">{prefecture.label}</p>
            <ul
              className="nbs-territory-tree__localities"
              aria-label={`Localités — ${prefecture.label}`}
            >
              {prefecture.localities.map((place) => {
                const selected = selectedId === place.id;
                if (interactive && onSelect) {
                  return (
                    <li key={place.id}>
                      <button
                        type="button"
                        className="nbs-territory-tree__locality-btn"
                        aria-pressed={selected}
                        onClick={() => onSelect(place.id)}
                      >
                        <span className="nbs-territory-tree__locality-name">{place.label}</span>
                        <span className="nbs-territory-tree__locality-kind">{place.kind}</span>
                      </button>
                    </li>
                  );
                }
                return (
                  <li key={place.id} className="nbs-territory-tree__locality">
                    <strong>{place.label}</strong>
                    <span>{place.kind}</span>
                  </li>
                );
              })}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}
